module.exports = JSON;


//////////////////
// WEBPACK FOOTER
// external "JSON"
// module id = 250
// module chunks = 0